import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function PostCleaningRound() {
  const navigate = useNavigate();
 


  const [formData, setFormData] = useState({
    title: "",
    price: "",
    total_cut_value: "",
    yearly_revenue: "",
    clients_count: "",
    suburb: "",
    state: "",
    postcode: "",
    description: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    if (submitting) return;
setSubmitting(true);

    const token = localStorage.getItem("token");
    if (!token) {
      setErrorMessage("Authentication expired. Please log in again.");
      setSubmitting(true);
      return;
    }

    try {
     const payload = {
  title: formData.title.trim(),
  description: formData.description.trim(),
  price: Number(formData.price),
  total_cut_value: Number(formData.total_cut_value || 0),
  yearly_revenue: Number(formData.yearly_revenue),
  clients_count: Number(formData.clients_count),
  suburb: formData.suburb.trim(),
  state: formData.state,
  postcode: formData.postcode.trim(),
  enquiry_only: 1
};
      const res = await axios.post(
        `${API_BASE_URL}/api/cleaning/rounds/create`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

     if (res.data.success && res.data.checkout_url) {
  window.location.href = res.data.checkout_url;
} else {
  setErrorMessage("Failed to create listing.");
  setSubmitting(false);
}
    } catch (err) {
      console.error("Cleaning round creation error:", err);
      setErrorMessage("Server error creating listing.");
      setSubmitting(false);
    }
  };

  // =============================
  // UI STYLES — MATCH MOWING
  // =============================
  const container = {
    maxWidth: "700px",
    margin: "120px auto 20px",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    position: "relative",
  };

  const header = {
    color: "#2e7d32",
    fontWeight: "bold",
    fontSize: "1.6rem",
    marginBottom: "20px",
  };

  const sectionHeader = {
    background: "#e8f5e9",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "20px",
    fontWeight: "bold",
    color: "#1b5e20",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const submitButton = {
    width: "100%",
    padding: "14px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    fontSize: "1.2rem",
    fontWeight: "bold",
    borderRadius: "8px",
    marginTop: "25px",
    cursor: "pointer",
  };

  return (
    <div style={container}>
      <div style={header}>Create Cleaning Round Listing</div>

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      <form onSubmit={handleSubmit}>
        <div style={sectionHeader}>Round Information</div>

        <label>Round Title</label>
        <input
          name="title"
          style={inputStyle}
          value={formData.title}
          onChange={handleChange}
          required
        />

        <label>Sale Price ($)</label>
        <input
          type="number"
          name="price"
          style={inputStyle}
          value={formData.price}
          onChange={handleChange}
          required
        />

        <label>Total Clean Value ($)</label>
        <input
          type="number"
          name="total_cut_value"
          style={inputStyle}
          value={formData.total_cut_value}
          onChange={handleChange}
        />

        <label>Yearly Revenue ($)</label>
        <input
          type="number"
          name="yearly_revenue"
          style={inputStyle}
          value={formData.yearly_revenue}
          onChange={handleChange}
          required
        />

        <label>Number of Clients</label>
        <input
          type="number"
          name="clients_count"
          style={inputStyle}
          value={formData.clients_count}
          onChange={handleChange}
          required
        />

        <label>Suburb</label>
        <input
          name="suburb"
          style={inputStyle}
          value={formData.suburb}
          onChange={handleChange}
          required
        />

        <label>State</label>
        <select
          name="state"
          value={formData.state}
          onChange={handleChange}
          style={inputStyle}
          required
        >
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label>Postcode (optional)</label>
        <input
          name="postcode"
          style={inputStyle}
          value={formData.postcode}
          onChange={handleChange}
        />

        <label>Description</label>
        <textarea
          name="description"
          rows="4"
          style={inputStyle}
          value={formData.description}
          onChange={handleChange}
          required
        />

      <button type="submit" style={submitButton} disabled={submitting}>
  {submitting ? "Processing..." : "Post Cleaning Round Listing"}
</button>
      </form>
    </div>
  );
}
